import { render, staticRenderFns } from "./EditStatusCompanyModal.vue?vue&type=template&id=00a8c25a&"
import script from "./EditStatusCompanyModal.vue?vue&type=script&lang=ts&"
export * from "./EditStatusCompanyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports